import React from "react";
import { Form, Dropdown, Accordion } from "react-bootstrap";
import styles from "./teams.module.scss";
import { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import Card from "react-bootstrap/Card";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import leftarr from "../../styles/images/leftpagination.svg";
import rightarr from "../../styles/images/rightpagination.svg";
import deleteicon from "../../styles/images/deleteicongray.svg";
import { useNavigate  } from 'react-router-dom';
import { useSelector } from "react-redux";

function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    console.log("totally custom!")
  );
  return (
    <button type="button" onClick={decoratedOnClick}>
      {children}
    </button>
  );
}

const Accounts = () => {
  let navigate = useNavigate();
  
  const directRoutingToken = useSelector((state: any) => state.profile);

  const { SearchBar, ClearSearchButton } = Search;

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </span>
  );
  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: <img src={leftarr} />,
    nextPageText: <img src={rightarr} />,
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "All",
      },
    ],
  };
  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
      formatter: (base: any) => {
        return (
          <div className={styles.namelogo}>
            <h3>JN</h3>
            <p>Ronald Richards</p>
          </div>
        );
      },
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
    },
    {
      dataField: "roles",
      text: "Roles",
      formatter: (base: any) => {
        return (
          <span>
            <input type="text" readOnly />
          </span>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter:(base:any)=>{
        return <img src={deleteicon} alt="delete" />
      }
    },
  ];
  const data = [{}];

  const changePage =(key :number)=> {
    console.log("key0000000",key);
    switch(key) {
      case 1 : 
       navigate('/directrouting')
      break;

      case 2 : 
       navigate('/directrouting/adminsetup')
      break;

      case 3 : 
       navigate('/directrouting/pbx')
      break;
      
      case 4 : 
       navigate('/directrouting/teams')
      break;

      case 5 : {
        if(directRoutingToken.teamsToken){
          navigate('/userlist')
        }
      }
      break;
      
      default : 
       navigate('/directrouting')
      break;
    }
  
  }

  return (
    <>
      <div className="breadcrumbarea">
        <h4>Teams Integration</h4>
        <p>Direct Routing allows connecting the Teams Phone calling system through Worktual that enabling seamless voice communication capabilities.</p>
      </div>
        
      <div className={styles.teamstab}>
      
      <ul>
        
        <li onClick={()=>{changePage(1)}}>
          <span>1</span>
          <h5>Domain verification</h5>
        </li>

        <li onClick={()=>{changePage(2)}}>
          <span>2</span>
          <h5>Admin Setup</h5>
        </li>

        <li onClick={()=>{changePage(3)}}>
          <span>3</span>
          <h5>Servicespbx</h5>
        </li>

        <li onClick={()=>{changePage(4)}}>
          <span>4</span>
          <h5>Servicesteams</h5>
        </li>

        <li onClick={()=>{changePage(5)}}>
          <span>5</span>
          <h5>User</h5>
        </li>

        <li className={styles.activetab}>
          <span>6</span>
          <h5>Account</h5>
        </li>

      </ul>
      </div>
      <div className={styles.acccontain}>
        <div className={styles.topheader}>
          <div className={styles.topheaderleft}>
            <div className="searchclear">
              <SearchBar />
              <ClearSearchButton className="clears" />
            </div>
            <p>
              Advanced Filter{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="6"
                viewBox="0 0 12 6"
                fill="none"
              >
                <path
                  d="M6.00007 5.90231C5.39757 5.90231 4.83207 5.66791 4.40677 5.24121L0.553271 1.37691C0.260771 1.08391 0.261771 0.609307 0.554771 0.316407C0.848671 0.024407 1.32377 0.0244068 1.61577 0.318407L5.46877 4.18271C5.75247 4.46591 6.24807 4.46591 6.53077 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59327 5.24121C7.16797 5.66801 6.60217 5.90231 6.00007 5.90231Z"
                  fill="#00B885"
                />
              </svg>
            </p>
          </div>
          <div className={styles.topheaderright}>
            <Dropdown className="customdropsync">
              <Dropdown.Toggle variant="success" id="dropdown-basic">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <path
                    d="M10 0.460938C4.4771 0.460938 0 4.93804 0 10.4609C0 15.9838 4.4772 20.4609 10 20.4609C15.5228 20.4609 20 15.9836 20 10.4609C20 4.93824 15.5228 0.460938 10 0.460938ZM14.7787 7.67704L10.2518 13.5725C9.8539 14.0911 9.2513 14.4094 8.5985 14.4475C8.555 14.4504 8.5111 14.4514 8.4676 14.4514C7.8607 14.4514 7.2786 14.2073 6.8529 13.7688L5.2782 12.1467C4.9896 11.8498 4.9965 11.3742 5.2938 11.0862C5.5911 10.7982 6.0663 10.8059 6.3543 11.1018L7.929 12.7239C8.0833 12.8821 8.2806 12.9671 8.5115 12.9505C8.7322 12.9378 8.9275 12.8343 9.0623 12.6585L13.5892 6.76304C13.8412 6.43494 14.3138 6.37344 14.6405 6.62534C14.9691 6.87734 15.0311 7.34794 14.7787 7.67704Z"
                    fill="#00B885"
                  />
                </svg>{" "}
                Sync Now{" "}
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="7"
                    viewBox="0 0 12 7"
                    fill="none"
                  >
                    <path
                      d="M6.00009 6.36324C5.39759 6.36324 4.83209 6.12884 4.40679 5.70214L0.553286 1.83784C0.260786 1.54484 0.261786 1.07024 0.554786 0.777344C0.848686 0.485344 1.32379 0.485344 1.61579 0.779344L5.46879 4.64364C5.75249 4.92684 6.24809 4.92684 6.53079 4.64364L10.3843 0.779344C10.6763 0.485444 11.1514 0.485444 11.4453 0.777344C11.7383 1.07034 11.7392 1.54494 11.4468 1.83784L7.59329 5.70214C7.16799 6.12894 6.60219 6.36324 6.00009 6.36324Z"
                      fill="#00B885"
                    />
                  </svg>
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div className={styles.accbody}>
          <Accordion defaultActiveKey="0" className="teamscustomaccord">
            <Card>
              <Card.Header className={styles.headercolor1}>
                <CustomToggle eventKey="0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="6"
                    viewBox="0 0 12 6"
                    fill="none"
                  >
                    <path
                      d="M10.9154 5.90318C10.723 5.90318 10.5306 5.82998 10.3842 5.68248L6.53069 1.81728C6.38909 1.67568 6.20059 1.59758 5.99989 1.59658C5.79919 1.59658 5.61029 1.67568 5.46819 1.81728L1.61569 5.68248C1.32369 5.97638 0.848086 5.97638 0.555186 5.68448C0.261686 5.39148 0.260787 4.91688 0.553187 4.62398L4.40619 0.75878C4.83199 0.33198 5.39789 0.0966797 5.99999 0.0966797C6.60209 0.0976797 7.16799 0.33208 7.59329 0.75878L11.4468 4.62398C11.7393 4.91698 11.7383 5.39158 11.4448 5.68448C11.2988 5.82998 11.1068 5.90318 10.9154 5.90318Z"
                      fill="#757676"
                    />
                  </svg>{" "}
                  Manage Admins
                </CustomToggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                <div className="teamsinnerpagination">
                  <BootstrapTable
                    keyField="serviceid"
                    data={data}
                    columns={columns}
                    pagination={paginationFactory(options)}
                  />
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Card.Header className={styles.headercolor2}>
                <CustomToggle eventKey="1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="6"
                    viewBox="0 0 12 6"
                    fill="none"
                  >
                    <path
                      d="M10.9154 5.90318C10.723 5.90318 10.5306 5.82998 10.3842 5.68248L6.53069 1.81728C6.38909 1.67568 6.20059 1.59758 5.99989 1.59658C5.79919 1.59658 5.61029 1.67568 5.46819 1.81728L1.61569 5.68248C1.32369 5.97638 0.848086 5.97638 0.555186 5.68448C0.261686 5.39148 0.260787 4.91688 0.553187 4.62398L4.40619 0.75878C4.83199 0.33198 5.39789 0.0966797 5.99999 0.0966797C6.60209 0.0976797 7.16799 0.33208 7.59329 0.75878L11.4468 4.62398C11.7393 4.91698 11.7383 5.39158 11.4448 5.68448C11.2988 5.82998 11.1068 5.90318 10.9154 5.90318Z"
                      fill="#757676"
                    />
                  </svg>{" "}
                  Manage Admins
                </CustomToggle>
              </Card.Header>
              <Accordion.Collapse eventKey="1">
                <Card.Body>
                <div className="teamsinnerpagination">
                  <BootstrapTable
                    keyField="serviceid"
                    data={data}
                    columns={columns}
                    pagination={paginationFactory(options)}
                  />
                </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>
      </div>
      <div className={styles.footerbtndouble}>
        <button className={styles.backbtn}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="12"
            viewBox="0 0 6 12"
            fill="none"
          >
            <path
              d="M5.15277 11.666C4.96137 11.666 4.76947 11.5928 4.62297 11.4472L0.758268 7.59371C0.332468 7.16891 0.0976688 6.60351 0.0971688 6.00091C0.0966688 5.39831 0.331568 4.83291 0.758268 4.40621L4.62347 0.553711C4.91647 0.261711 5.39157 0.261712 5.68397 0.555712C5.97647 0.848712 5.97547 1.32331 5.68197 1.61621L1.81727 5.46871C1.67517 5.61031 1.59707 5.79981 1.59707 6.00091C1.59707 6.20111 1.67517 6.38961 1.81727 6.53121L5.68247 10.3847C5.97547 10.6777 5.97637 11.1523 5.68397 11.4452C5.53747 11.5927 5.34507 11.666 5.15277 11.666Z"
              fill="#575CFF"
            />
          </svg>{" "}
          Back
        </button>
        <div className={styles.btnflexx}>
          <button className="cancelbtn" onClick={()=>navigate('/userlist')}>Cancel</button>
          <button>Save</button>
        </div>
      </div>
    </>
  );
};

export default Accounts;
